import React, { useState, useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Footer from './Footer';
import FloatingFeedbackButton from './FloatingFeedbackButton';

function MainLayout() {
  const [user, setUser] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/';
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchKeyword.trim()) {
      window.location.href = `/search?keyword=${encodeURIComponent(searchKeyword.trim())}`;
    }
  };

  return (
    <>
      {/* Header */}
      <div id="header">
        <h1>
          <Link to="/">
            <img src="/images/logo.jpg" alt="logo" border="0" />
          </Link>
        </h1>

        {/* GNB */}
        <ul id="gnb">
          <li>
            <Link to="/board/notice">
              <span>알림방</span>
            </Link>
          </li>
          <li>
            <Link to="/board/free">
              <span>사랑채</span>
            </Link>
          </li>
          <li>
            <Link to="/board/sermon">
              <span>설교모음</span>
            </Link>
          </li>
          <li>
            <Link to="/board/mark">
              <span>매일묵상</span>
            </Link>
          </li>
          <li>
            <Link to="/theo">
              <span>신학마당</span>
            </Link>
          </li>
        </ul>

        {/* 검색 폼 */}
        <form onSubmit={handleSearch} id="isSearch">
          <input
            name="is_keyword"
            type="text"
            className="inputText"
            title="keyword"
            placeholder="검색"
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
          <input type="submit" value="검색" className="submit" />
        </form>

        {/* 상단인덱스메뉴 */}
        <div id="top_index">
          <Link to="/about">다비아소개</Link> |
          <Link to="/board/member">후원안내</Link> |
          {user ? (
            <>
              <span>{user.nick_name}님</span> |
              <button onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>로그아웃</button> |
            </>
          ) : (
            <>
              <Link to="/login">로그인</Link> |
              <Link to="/signup">회원가입</Link> |
            </>
          )}
          <Link to="/mypage">마이페이지</Link>
          {user && (user.is_admin === 'Y' || user.nick_name === '정용섭') && (
            <>
              {' | '}
              <Link to="/admin">관리자</Link>
            </>
          )}
        </div>
      </div>

      {/* Main Content */}
      <Outlet />

      {/* Footer */}
      <Footer />

      {/* Floating Feedback Button */}
      <FloatingFeedbackButton />
    </>
  );
}

export default MainLayout;
